import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { CTMSMapComponent } from '@ruby/shared/components/ctms-map/ctms-map.component';
import { MapModule } from '@ruby/shared/map/map.module';

@NgModule({
  declarations: [CTMSMapComponent],
  imports: [
    CommonModule,
    FormsModule,
    MapModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatToolbarModule,
    NSSkeletonModule
  ],
  exports: [CTMSMapComponent]
})
export class CTMSMapModule {}
